import axios from "axios";
import config from "./index";
import util from "../util";
//https://cors-anywhere.herokuapp.com/" +
const instance = axios.create({
  baseURL: config.apiBaseURL,
});

instance.interceptors.request.use(
  (configurations) => {
    // Event before every API call (GET, POST, PUT, DELETE, etc.)
    const apiEvent = new CustomEvent('apiCallStarted', {
      detail: {
        method: configurations.method?.toUpperCase() || 'UNKNOWN',
        url: configurations.url,
        baseURL: configurations.baseURL,
        fullURL: configurations.baseURL + configurations.url,
        timestamp: new Date().toISOString(),
        headers: configurations.headers,
        data: configurations.data,
        params: configurations.params
      }
    });
    
    // Dispatch the event
    window.dispatchEvent(apiEvent);
    
    // Log to console for debugging
    console.log(`🚀 API Call Started: ${configurations.method?.toUpperCase()} ${configurations.url}`, {
      method: configurations.method?.toUpperCase(),
      url: configurations.url,
      timestamp: new Date().toISOString(),
      data: configurations.data,
      params: configurations.params
    });

    let tokenInfo = util.getAuthTokens();

    if (tokenInfo.access_token)
      configurations.headers[config.access_token_name] = tokenInfo.access_token;

    if (tokenInfo.refresh_token)
      configurations.headers[config.refresh_token_name] =
        tokenInfo.refresh_token;

    return configurations;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Event after successful API call
    const apiSuccessEvent = new CustomEvent('apiCallCompleted', {
      detail: {
        method: response.config.method?.toUpperCase() || 'UNKNOWN',
        url: response.config.url,
        status: response.status,
        statusText: response.statusText,
        timestamp: new Date().toISOString(),
        data: response.data
      }
    });
    
    // Dispatch the success event
    window.dispatchEvent(apiSuccessEvent);
    
    // Log successful response
    console.log(`✅ API Call Completed: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      status: response.status,
      statusText: response.statusText,
      timestamp: new Date().toISOString()
    });

    const respData = response.data.data ? response.data.data : null;
    if (
      response.status === 200 &&
      respData &&
      respData.access_token_expired &&
      respData.new_access_token
    ) {
      util.setAccessToken(respData.new_access_token);

      response.config.headers.access_token = JSON.stringify(
        respData.new_access_token
      );

      return instance.request(response.config);
    }

    return response;
  },
  (error) => {
    // Event after failed API call
    const apiErrorEvent = new CustomEvent('apiCallFailed', {
      detail: {
        method: error.config?.method?.toUpperCase() || 'UNKNOWN',
        url: error.config?.url,
        status: error.response?.status,
        statusText: error.response?.statusText,
        error: error.message,
        timestamp: new Date().toISOString(),
        errorData: error.response?.data
      }
    });
    
    // Dispatch the error event
    window.dispatchEvent(apiErrorEvent);
    
    // Log failed response
    console.log(`❌ API Call Failed: ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
      status: error.response?.status,
      statusText: error.response?.statusText,
      error: error.message,
      timestamp: new Date().toISOString(),
      errorData: error.response?.data
    });

    const erroResp =
      error.response && error.response.data ? error.response.data.data : null;
    if (
      error.response &&
      error.response.status === 401 &&
      erroResp &&
      erroResp.refresh_token_expired
    ) {
      window.location.href = config.authLogoutUrl;
    }
    
    // Important: Return Promise.reject to propagate the error to catch blocks
    return Promise.reject(error);
  }
);

export default instance;
